export default __webpack_public_path__ + "static/media/hatching-icon.2a68b360.svg";